export function isInternal(url) {
  if (!url) return false
  try {
    return new URL(url, window.location.href).origin === window.location.origin
  } catch {
    return false
  }
}

export function openInternal(url) {
  if (!url) return
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches
  if (isStandalone) {
    window.open(url, "_blank", "popup,width=1200,height=900")
  } else {
    window.open(url, "_blank")
  }
}
